// extracted by mini-css-extract-plugin
export default {"nav-icon-5":"HamburgerButton_nav-icon-5__CmSUb","open":"HamburgerButton_open__caItQ"};